import { Action } from 'redux';

export const MANAGER_NOTES_FETCH_SUCCESS = 'MANAGER_NOTES_FETCH_SUCCESS';
export const MANAGER_NOTES_FETCH_ERROR = 'MANAGER_NOTES_FETCH_ERROR';
export const MANAGER_NOTES_FETCH_LOADING = 'MANAGER_NOTES_FETCH_LOADING';
export const MANAGER_NOTES_ANSWER_SUCCESS = 'MANAGER_NOTES_ANSWER_SUCCESS';
export const MANAGER_NOTES_ANSWER_LOADING = 'MANAGER_NOTES_ANSWER_LOADING';
export const MANAGER_NOTES_ANSWER_ERROR = 'MANAGER_NOTES_ANSWER_ERROR';

export interface ReduxAction extends Action {
    payload?: object;
    error?: boolean;
    meta?: object;
}

export interface ManagerNotesFetchSuccess extends ReduxAction {
    type: typeof MANAGER_NOTES_FETCH_SUCCESS;
    payload: any;
}

export interface ManagerNotesFetchError extends ReduxAction {
    type: typeof MANAGER_NOTES_FETCH_ERROR;
    error: boolean;
    payload: any;
}

export interface ManagerNotesFetchLoading extends ReduxAction {
    type: typeof MANAGER_NOTES_FETCH_LOADING;
    payload: { loading: boolean; answers?: Array<any> };
}

export interface ManagerNotesAnswerSuccess extends ReduxAction {
    type: typeof MANAGER_NOTES_ANSWER_SUCCESS;
    payload: any;
}

export interface ManagerNotesAnswerError extends ReduxAction {
    type: typeof MANAGER_NOTES_ANSWER_ERROR;
    error: boolean;
    payload: { error: Error };
}

export interface ManagerNotesAnswerLoading extends ReduxAction {
    type: typeof MANAGER_NOTES_ANSWER_LOADING;
    payload: { answerLoading: boolean };
}
